<template>
    <div class="box">
        <div class="operation">
            <el-form ref="form" :model="form" label-width="80px" class="form" :inline="true">
                <el-form-item label="轮播图名称" label-position="right" class="mt">
                    <el-input v-model="form.bannerName" size="small" placeholder="请输入轮播图名称"></el-input>
                </el-form-item>
                <el-form-item label="位置" label-position="right" class="mt">
                    <el-select v-model="form.position" placeholder="请选择" clearable>
                        <el-option label="首页" value="0"></el-option>
                        <el-option label="商学院" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="跳转方式" label-position="right" class="mt">
                    <el-select v-model="form.jumpMode" placeholder="请选择" clearable>
                        <el-option label="外部链接" value="0"></el-option>
                        <el-option label="内部链接" value="1"></el-option>
                        <el-option label="图文内容" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" label-position="right" class="mt">
                    <el-select v-model="form.state" placeholder="请选择" clearable>
                        <el-option label="上架" value="0"></el-option>
                        <el-option label="下架" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="mt">
                <el-button type="primary" class="btn" @click="queryFunc" icon="el-icon-search">查询</el-button>
                <el-button class="btn" @click="clearFunc" icon="el-icon-delete">重置</el-button>
                <el-button type="primary" icon="el-icon-plus" class="btn" @click="add">新建</el-button>
                <el-button :underline="false" type="danger" @click="delBannerFunc" :disabled="!selectedRows.length"
                    icon="el-icon-delete">删除</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="tabBox">
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange"
                style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="bannerName" label="标题">
                </el-table-column>
                <el-table-column label="图片" prop="bannerPicture">
                    <template slot-scope="scope">
                        <img :src="scope.row.bannerPicture" alt="" style="width: 60%;height: 60%;">
                    </template>
                </el-table-column>
                <el-table-column prop="position" label="位置" sortable>
                    <template slot-scope="scope">
                        {{ scope.row.position == 0 ? '首页' : '商学院' }}
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态">
                    <template slot-scope="scope">
                        {{ scope.row.state == 0 ? '上架' : '下架' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="dis">
                            <el-link :underline="false" type="primary" @click="update(scope.row)">修改</el-link>
                            <el-link :underline="false" type="danger" @click="delBanner(scope.row)" class="ml">删除</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagelndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <el-dialog :title="title" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
            <AddView v-if="dialogFormVisible" @closeFunction="bannerListFunc(); itemData = null; dialogFormVisible = false"
                :itemDataList="itemData">
            </AddView>
        </el-dialog>
    </div>
</template>

<script>
import AddView from './components/AddView.vue';
import UpdateView from './components/UpdateView.vue';
import bannerApi from '@/api/setting/banner.js'
export default {
    data() {
        return {
            form: {
                bannerName: '', // banner名称
                position: '', // 位置（0:首页；1:商学院）
                jumpMode: '', // 跳转方式（0：外部链接；1：内部链接；2:图文内容）
                state: '', // 状态
            },
            tableData: [],
            loading: false, // 表格加载
            total: 0, // 总数
            pageSize: 10, // 条数
            pagelndex: 1, // 页数
            selectedRows: [], // 全选/单选
            dialogFormVisible: false,
            itemData: null,
            title: null,
        }
    },
    components: { AddView, UpdateView },
    methods: {
        // 轮播图单独删除
        delBanner(row) {
            const ids = row.id;
            this.$confirm('此操作将永久删除此条信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                bannerApi.getDelBanner({ ids: ids }).then(res => {
                    this.loading = false;
                    this.bannerListFunc()
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(err => {
                    // console.log(err);
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleSelectionChange(val) {
            this.selectedRows = val;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.bannerListFunc();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.pageIndex = val;
            this.bannerListFunc();
        },
        // 渲染列表
        bannerListFunc() {
            const params = {
                bannerName: this.form.bannerName,
                position: this.form.position,
                jumpMode: this.form.jumpMode,
                state: this.form.state,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            this.loading = true;
            bannerApi.getBannnerList({ ...params }).then(res => {
                // console.log(res)
                this.tableData = res.data.records
                this.total = res.data.total
                this.loading = false;
            }).catch(err => {
                // console.log(err);
            })
        },
        // 查询按钮
        queryFunc() {
            this.bannerListFunc();
        },
        // 重置
        clearFunc() {
            this.form.bannerName = '';
            this.form.position = '';
            this.form.jumpMode = '';
            this.form.state = '';
            this.bannerListFunc();
        },
        // 新增
        add() {
            this.title = '新增轮播图'
            this.dialogFormVisible = true;
        },
        // 编辑
        update(data) {
            this.title = '编辑轮播图'
            this.itemData = data
            this.dialogFormVisible = true
        },
        // 删除
        delBannerFunc() {
            if (this.selectedRows.length !== 0) {
                const ids = this.selectedRows.map(row => row.id);

                const params = ids.join(',')
                // console.log(ids, params);
                this.$confirm('此操作将永久删除此条信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    bannerApi.getDelBanner({ ids: params }).then(res => {
                        // console.log(res)
                        this.loading = false;
                        this.bannerListFunc()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }).catch(err => {
                        // console.log(err);
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },

    },
    mounted() {
        this.bannerListFunc();
    },
}
</script>

<style scoped>
.dis {
    display: flex;
    align-items: center;
    /* justify-items: center; */
}

.ml {
    margin-left: 20px;
}

.tabBox {
    margin: 40px 0;
}

.box {
    padding: 10px;
}

.mt {
    margin-top: 20px;
}

.form {
    margin-right: 20px;
}

.btn {
    margin-left: 15px;
}

.el-form-item {
    margin-bottom: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/banner/index.vue